// 顧客種別一覧画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { ConstructTypeCreateModal } from '../components/constructType/ConstructTypeCreateModal';
import { ConstructTypeDeleteModal } from '../components/constructType/ConstructTypeDeleteModal';
import { ConstructTypeUpdateModal } from '../components/constructType/ConstructTypeUpdateModal';
import FooterComponent from '../components/FooterComponent';
import { TConstructTypeItem } from '../types/ConstructTypeMaster';
import { Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  isLoggedIn,
  mainBlueColor,
  btnColor,
  constructTypeData,
  userMenuId
} from '../GlobalState';
import {
  getConstructTypeList,
  deleteConstructTypeMaster,
  updateConstructTypeMaster,
  createConstructTypeMaster
} from '../apicalls/constructType';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

export const ConstructTypePage: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        paddingTop: 30,
        paddingBottom: 30,
        marginTop: 30,
        marginBottom: 30
      },

      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 8,
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {
        padding: 8
      },
      inputtype: {
        minHeight: 45,
        marginBottom: 5,
        width: '100%',
        paddingLeft: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderRadius: 5
      }
    })
  );

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  // 各モーダルの開閉
  const [constructTypeCreateModal, setConstructTypeCreateModal] =
    useState<boolean>(false);
  const [constructTypeDeleteModal, setConstructTypeDeleteModal] =
    useState<boolean>(false);
  const [constructTypeUpdateModal, setConstructTypeUpdateModal] =
    useState<boolean>(false);
  // クリックした項目を格納
  const [selectItem, setSelectItem] = useState<TConstructTypeItem>({
    id: 0,
    name: '',
    order_id: 0
  });

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();

  const [constructTypeApiData, setConstructTypeApiData] =
    useRecoilState(constructTypeData);
  const changeConstructTypeApiData = (newData: any) =>
    setConstructTypeApiData(newData);

  const [apiData, setApiData] = useState<any>(
    constructTypeApiData !== null ? constructTypeApiData : []
  );
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(
    constructTypeApiData !== null ? false : true
  );
  const [userMenu] = useRecoilState<any>(userMenuId);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  /**
   *  一覧取得
   */
  const getListOfConstructTypeMasters = useCallback(() => {
    getConstructTypeList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeConstructTypeApiData(data.data);
            setApiData(data.data);
            setLoading(false);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  /**
   *  新規作成
   */
  const createConstructType = (name: string) => {
    createConstructTypeMaster(name).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            getListOfConstructTypeMasters();
          }
        }
      }
    });
  };

  /**
   * 削除
   */
  const deleteConstructType = () => {
    deleteConstructTypeMaster(selectItem.id).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            getListOfConstructTypeMasters();
          }
        }
      }
    });
  };

  /**
   * 編集
   */
  const updateConstructType = (name: string) => {
    updateConstructTypeMaster(selectItem.id, name).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            getListOfConstructTypeMasters();
          }
        }
      }
    });
  };

  useEffect(() => {
    getListOfConstructTypeMasters();
  }, [getListOfConstructTypeMasters]);

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='construct_types' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          {openSuccess ? (
            <Snackbar
              open={openSuccess}
              autoHideDuration={2000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {successMessage}
              </Alert>
            </Snackbar>
          ) : null}
          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            {/* 新規作成モーダル */}
            <ConstructTypeCreateModal
              construtTypeCreateModal={constructTypeCreateModal}
              setConstructTypeCreateModal={setConstructTypeCreateModal}
              createConstructType={createConstructType}
            />
            {/* 削除モーダル */}
            <ConstructTypeDeleteModal
              selectItem={selectItem}
              constructTypeDeleteModal={constructTypeDeleteModal}
              setConstructTypeDeleteModal={setConstructTypeDeleteModal}
              deleteConstructType={deleteConstructType}
            />
            {/* 編集モーダル */}
            <ConstructTypeUpdateModal
              selectedConstrutTypeName={selectItem.name}
              construtTypeUpdateModal={constructTypeUpdateModal}
              setConstructTypeUpdateModal={setConstructTypeUpdateModal}
              updateConstructType={updateConstructType}
            />

            <div className='table-top-container-customer'>
              <div className='question-position'>
                <div style={{ fontWeight: 'bold' }}>案件種別マスタ</div>
                <CustomTooltip
                  title={tooltipContents.constructType}
                  placement='right'
                >
                  <HelpIcon
                    color='action'
                    style={{ marginLeft: 8, marginTop: 4 }}
                  />
                </CustomTooltip>
              </div>
              <div style={{ display: 'flex' }}>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => {
                    setConstructTypeCreateModal(true);
                  }}
                >
                  案件種別を追加
                </Button>
              </div>
            </div>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      種別
                    </StyledTableCell>

                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 550 }}
                        align='center'
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                      >
                        {row.count}件の工事で使用中
                      </StyledTableCell>

                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant='contained'
                          color='primary'
                          onClick={() => {
                            setConstructTypeUpdateModal(true);
                            setSelectItem(row);
                          }}
                        >
                          編集
                        </Button>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant='contained'
                          color='primary'
                          onClick={() => {
                            setConstructTypeDeleteModal(true);
                            setSelectItem(row);
                          }}
                        >
                          削除
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
